import { render, staticRenderFns } from "./VuesticPageNotFoundLargeText.vue?vue&type=template&id=8b4c30ae&"
import script from "./VuesticPageNotFoundLargeText.vue?vue&type=script&lang=js&"
export * from "./VuesticPageNotFoundLargeText.vue?vue&type=script&lang=js&"
import style0 from "./VuesticPageNotFoundLargeText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticPageNotFoundLargeText.vue"
export default component.exports